import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import services from '../api/services'

const ConfirmReservation = ({ match: { params } }) => {
  const [status, setStatus] = React.useState('Bitte warten…')

  React.useEffect(() => {
    if (!params.hash || params.hash.length !== 64) {
      return setStatus('Der aufgerufene Link ist ungültig.')
    }

    services.confirm.create({ hash: params.hash }).then(
      () =>
        setStatus(
          'Vielen Dank! Ihre E-Mail-Adresse wurde bestätigt. Ihre Buchungsanfrage ist nun aktiv.'
        ),
      (e) => setStatus(`Es ist ein Fehler aufgetreten: ${e.message}`)
    )
  }, [params.hash])

  const title = 'E-Mail-Adresse bestätigen'

  return (
    <div className="flex h-screen justify-center p-4">
      <Helmet>
        <title>
          {window.document.head.dataset.titlePrefix} | {title}
        </title>
      </Helmet>

      <div className="self-center rounded bg-white p-8 text-center shadow-xl">
        <h1 className="text-2xl">{title}</h1>
        <p className="mt-2">{status}</p>
      </div>
    </div>
  )
}

ConfirmReservation.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      hash: PropTypes.string.isRequired
    })
  })
}

export default ConfirmReservation
